import moment from "moment";
import { Form, Input, Switch, Select, DatePicker, Radio } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import UploadImage from "../_shared/UploadImage";
import { getClientTypes } from "../../redux/actions/accountActions";
import { RootState } from "../../redux/rootReducer";
import { Actions, AccountType } from "../../shared/constant";

function ClientInfoForm({
  onFileUpload,
  mode,
  editData,
  clientForm,
}: {
  onFileUpload: Function;
  mode: string;
  editData: any;
  clientForm: any;
}) {
  const [isActive, setIsActive] = useState(true);
  const dispatch = useDispatch();
  const { clientTypes } = useSelector((state: RootState) => state.account);

  useEffect(() => {
    if (mode === Actions.EDIT) {
      if (editData.status) setIsActive(true);
      else setIsActive(false);

      clientForm.setFieldsValue({
        name: editData.name,
        email: editData.email,
        // client_types: [...editData.client_types.map((item: any) => item.id)],
        client_types: editData.client_types[0].id,
        ...(editData.contract_start_date && {
          contract_start_date: moment(editData.contract_start_date),
        }),
        ...(editData.contract_end_date && {
          contract_end_date: moment(editData.contract_end_date),
        }),
        status: editData.status,
        hasExportPermission: editData.has_export_permission,
        isEmailNotification: editData.is_email_notification_active,
        isIncomeSharePdf: editData.is_pdf_income_share_visible,
        isClapChargePdf: editData.is_pdf_clap_charge_visible,
      });
    }
  }, [mode]);

  useEffect(() => {
    dispatch(getClientTypes());
  }, []);

  const onToggleSwitch = (checked: boolean) => {
    setIsActive(checked);
  };

  return (
    <div className="mb-[26px]">
      <div className="grid grid-cols-2 gap-x-6">
        <Form.Item name="name" label="Client Name" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name="parent_client" label="Parent Client" initialValue="1">
          <Select placeholder="Select" disabled>
            <Select.Option value="1">None</Select.Option>
          </Select>
        </Form.Item>
      </div>
      <Form.Item
        name="email"
        label="Email"
        rules={[{ required: true }, { type: "email" }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="Client Type"
        name="client_types"
        rules={[{ required: true }]}
      >
        <Radio.Group disabled={mode === Actions.EDIT}>
          {clientTypes.map(
            (type: any) =>
              type.label === AccountType.MEMBER && (
                <Radio key={type.id} value={type.id}>
                  {type.label}
                </Radio>
              ),
          )}
        </Radio.Group>
        {/* <Select
          mode="multiple"
          placeholder="Select"
          disabled={mode === Actions.EDIT}
        >
          {clientTypes.map((type: any) => (
            <Select.Option key={type.id} value={type.id}>
              {type.label}
            </Select.Option>
          ))}
        </Select> */}
      </Form.Item>
      <div className="grid grid-cols-2 gap-x-6">
        <Form.Item
          name="contract_start_date"
          label="Contract Start Date"
          initialValue=""
        >
          <DatePicker placeholder="" className="w-full" format="YYYY-MM-DD" />
        </Form.Item>
        <Form.Item
          name="contract_end_date"
          label="Contract End Date"
          initialValue=""
        >
          <DatePicker placeholder="" className="w-full" format="YYYY-MM-DD" />
        </Form.Item>
      </div>
      <Form.Item name="client_logo" label="Client Logo">
        <UploadImage onFileUpload={onFileUpload} />
      </Form.Item>
      <div className="grid grid-cols-2 gap-x-6">
        <div>
          <div className="flex gap-x-5 items-center">
            <div>
              <Form.Item
                valuePropName="checked"
                name="hasExportPermission"
                className="h-4"
                initialValue={false}
              >
                <Switch />
              </Form.Item>
            </div>
            <div className="h-5">Export permission</div>
          </div>
          <div className="flex gap-x-5 items-center">
            <div>
              <Form.Item
                valuePropName="checked"
                name="isEmailNotification"
                className="h-4"
                initialValue
              >
                <Switch />
              </Form.Item>
            </div>
            <div className="h-5">Email notification</div>
          </div>
          <div className="flex gap-x-5 items-center">
            <div>
              <Form.Item
                valuePropName="checked"
                name="status"
                className="h-4"
                initialValue
              >
                <Switch defaultChecked onChange={onToggleSwitch} />
              </Form.Item>
            </div>
            <div className="h-5">{isActive ? "Active" : "Inactive"}</div>
          </div>
        </div>
        <div>
          <div className="flex gap-x-5 items-center">
            <div>
              <Form.Item
                valuePropName="checked"
                name="isIncomeSharePdf"
                className="h-4"
                initialValue
              >
                <Switch />
              </Form.Item>
            </div>
            <div className="h-5">Show Income Share (PDF)</div>
          </div>
          <div className="flex gap-x-5 items-center">
            <div>
              <Form.Item
                valuePropName="checked"
                name="isClapChargePdf"
                className="h-4"
                initialValue
              >
                <Switch />
              </Form.Item>
            </div>
            <div className="h-5">Show CLAP service charge (PDF)</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ClientInfoForm;
